module.exports = __webpack_public_path__ + "img/User.ac1fa045.svg";